module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-7.f384cb75.png";